// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"182":"6152c06b","486":"9652e87b","778":"0fd0b5b7","938":"cc513378"}[chunkId] + ".chunk.css";
};